import { gtm } from '@shared';

import { moduleName } from '../constants';

export { ROUTE_PROFILE, ROUTE_OWN_ACTIVITY_LOGS } from '@shared';

export { rosterRequestIfNotLoaded as rosterRequest } from '../../advancement';

export const SET_EDIT_PROFILE = `${moduleName}/SET_EDIT_PROFILE`;
export const setEditProfile = edit => ({
  type: SET_EDIT_PROFILE,
  payload: edit,
});

export const SAVE_PROFILE_REQUEST = `${moduleName}/SAVE_PROFILE_REQUEST`;
export const SAVE_PROFILE_RESPONSE = `${moduleName}/SAVE_PROFILE_RESPONSE`;
export const SAVE_PROFILE_ERROR = `${moduleName}/SAVE_PROFILE_ERROR`;
export const saveProfileRequest = profile => ({
  type: SAVE_PROFILE_REQUEST,
  payload: profile,
  gtm: {
    category: gtm.categories.PROFILE,
  },
});
export const saveProfileResponse = () => ({
  type: SAVE_PROFILE_RESPONSE,
});
export const saveProfileError = err => ({
  type: SAVE_PROFILE_ERROR,
  payload: err,
});

export const SAVE_AKELA_PROFILE_REQUEST = `${moduleName}/SAVE_AKELA_PROFILE_REQUEST`;
export const SAVE_AKELA_PROFILE_RESPONSE = `${moduleName}/SAVE_AKELA_PROFILE_RESPONSE`;
export const SAVE_AKELA_PROFILE_ERROR = `${moduleName}/SAVE_AKELA_PROFILE_ERROR`;
export const saveAkelaProfileRequest = profiles => ({
  type: SAVE_AKELA_PROFILE_REQUEST,
  payload: profiles,
  gtm: {
    category: gtm.categories.PROFILE,
  },
});
export const saveAkelaProfileResponse = () => ({
  type: SAVE_AKELA_PROFILE_RESPONSE,
});
export const saveAkelaProfileError = err => ({
  type: SAVE_AKELA_PROFILE_ERROR,
  payload: err,
});
